import $ from "jquery";

export default function () {
    $('body').on('select2:select', '.js-select.form-control--code12nc', function (e) {
        let selectedData = $(this).select2('data');
        let selectedOption = selectedData[0].element;
        if (selectedOption.value === "-") {
            $(this).parents('.accordion-body').find('.model-wrap').removeClass('d-none')
        } else {
            $(this).parents('.accordion-body').find('.model-wrap').addClass('d-none')
        }
    });

    const $input12NC = $('select[data-name=code_12nc]');
    const $inputModel = $('select[data-name=model]');
    if ($input12NC.length) {
        ncSelect($input12NC);
        modelSelect($inputModel);
    }
}

export function ncSelect($input) {
    $input.select2({
        theme: "bootstrap-5",
        ajax: {
            url: getCodesUrl,
            dataType: 'json',
            // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            data: function (params) {
                let send = {
                    q: params.term
                };

                let category = this.parents('.accordion-collapse').find('input[data-name=category]:checked');
                if (category.length) {
                    send.category = category.val();
                }

                let twelvenc = this.parents('.accordion-collapse').find('select[data-name=code_12nc]');
                if (twelvenc.length && twelvenc.val() !== "" && twelvenc.val() !== "-") {
                    send.twelvenc = twelvenc.val();
                }

                return send;
            },
        }
    });
}

export function modelSelect($input) {
    $input.select2({
        theme: "bootstrap-5",
        ajax: {
            url: getModelsUrl,
            dataType: 'json',
            // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            data: function (params) {
                let send = {
                    q: params.term
                };

                let category = this.parents('.accordion-collapse').find('input[data-name=category]:checked');
                if (category.length) {
                    send.category = category.val();
                }

                // let model = this.parents('.accordion-collapse').find('select[data-name=model]');
                // if (model.length && model.val() !== "") {
                //     send.twelvenc = model.val();
                // }

                return send;
            },
        }
    });
}
